module.exports = __webpack_public_path__ + "img/f7942f7.png";